export const config = {
  hasuraEndpoint: process.env.REACT_APP_HASURA_ENDPOINT,
  frontendEndpoint: process.env.REACT_APP_FRONTEND_ENDPOINT,
};
